import {Alert, Button, Group, Text, TextInput} from '@mantine/core'
import {IconCalendarQuestion} from '@tabler/icons-react'
import {useState} from 'react'

import {toBusinessApiDateString} from '../jobs/job-schedule-format'

type DateTbcPanelProps = {
    onSetDate: (date: string) => Promise<void>
}

export function DateTbcPanel({onSetDate}: DateTbcPanelProps) {
    const today = toBusinessApiDateString(new Date())
    const [date, setDate] = useState(today)
    const [saving, setSaving] = useState(false)

    return (
        <Alert
            color="grape"
            variant="light"
            icon={<IconCalendarQuestion size={20} />}
            title="Date to be confirmed"
            data-testid="date-tbc-panel"
        >
            <Text size="sm" mb="xs">
                Shown on today&apos;s board until a date is set.
            </Text>
            <Group gap="xs" align="flex-end">
                <TextInput
                    type="date"
                    label="Date"
                    min={today}
                    value={date}
                    onChange={(event) => setDate(event.currentTarget.value)}
                    data-testid="date-tbc-input"
                />
                <Button
                    loading={saving}
                    disabled={!date || date < today}
                    onClick={async () => {
                        setSaving(true)
                        try {
                            await onSetDate(date)
                        } finally {
                            setSaving(false)
                        }
                    }}
                >
                    Set date
                </Button>
            </Group>
        </Alert>
    )
}
